import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bbf6a53"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hint" }, "Gom dịch vụ đã duyệt và nhân viên của khoa vào một nhóm. Nhân viên chính được thực hiện mọi dịch vụ trong nhóm; nhân viên phụ được phân công hỗ trợ. Quyền từ nhiều nhóm và phân công trực tiếp được kết hợp khi chia giờ. Dịch vụ chưa có nhân viên được phân công sẽ báo chưa xếp.", -1))
const _hoisted_2 = { class: "actions" }
const _hoisted_3 = { class: "actions" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Chưa có nhóm dịch vụ nội bộ trong khoa/phòng này.")
const _hoisted_5 = { class: "group-editor" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "ten-nhom-dich-vu" }, "Tên nhóm", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_BangChon = _resolveComponent("BangChon")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Nhóm dịch vụ nội bộ" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Button, {
          label: "Tạo nhóm dịch vụ",
          icon: "pi pi-plus",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sua())),
          disabled: _ctx.busy || !_ctx.khoa
        }, null, 8, ["disabled"]),
        _createVNode(_component_Button, {
          label: "Tải lại",
          icon: "pi pi-refresh",
          class: "p-button-text",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tai())),
          disabled: _ctx.busy
        }, null, 8, ["disabled"]),
        _createVNode(_component_Button, {
          label: "Xóa tất cả nhóm",
          icon: "pi pi-trash",
          class: "p-button-danger p-button-outlined",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.xoa())),
          disabled: _ctx.busy || !_ctx.groups.length
        }, null, 8, ["disabled"])
      ]),
      _createVNode(_component_DataTable, {
        value: _ctx.groups,
        loading: _ctx.loading,
        paginator: "",
        rows: 10,
        rowsPerPageOptions: [10,25,50],
        showGridlines: "",
        stripedRows: ""
      }, {
        empty: _withCtx(() => [
          _hoisted_4
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "tenNhom",
            header: "Tên nhóm",
            sortable: ""
          }),
          _createVNode(_component_Column, { header: "Dịch vụ" }, {
            body: _withCtx((row) => [
              _createTextVNode(_toDisplayString(row.data.dichVuIds.length), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Nhân viên chính" }, {
            body: _withCtx((row) => [
              _createTextVNode(_toDisplayString(row.data.nhanVienChinhIds.length), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Nhân viên phụ" }, {
            body: _withCtx((row) => [
              _createTextVNode(_toDisplayString(row.data.nhanVienPhuIds.length), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Thao tác" }, {
            body: _withCtx((row) => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_Button, {
                  label: "Xem / sửa",
                  class: "p-button-text",
                  onClick: ($event: any) => (_ctx.sua(row.data)),
                  disabled: _ctx.busy
                }, null, 8, ["onClick", "disabled"]),
                _createVNode(_component_Button, {
                  label: "Xóa",
                  class: "p-button-danger p-button-text",
                  onClick: ($event: any) => (_ctx.xoa(row.data)),
                  disabled: _ctx.busy
                }, null, 8, ["onClick", "disabled"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "loading"]),
      _createVNode(_component_Dialog, {
        class: "workflow-dialog",
        visible: _ctx.editing,
        "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editing) = $event)),
        header: _ctx.form.id ? 'Chỉnh sửa nhóm dịch vụ' : 'Tạo nhóm dịch vụ',
        modal: "",
        closable: !_ctx.busy,
        closeOnEscape: !_ctx.busy,
        style: _normalizeStyle({width:'min(1050px, 95vw)'}),
        contentStyle: {maxHeight:'75vh',overflow:'auto'}
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: "Hủy",
            class: "p-button-text",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.editing=false)),
            disabled: _ctx.busy
          }, null, 8, ["disabled"]),
          _createVNode(_component_Button, {
            label: "Lưu nhóm",
            icon: "pi pi-save",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.luu())),
            loading: _ctx.busy,
            disabled: _ctx.busy || !_ctx.form.tenNhom.trim() || !_ctx.form.dichVuIds.length || !_ctx.form.nhanVienChinhIds.length
          }, null, 8, ["loading", "disabled"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_InputText, {
              id: "ten-nhom-dich-vu",
              modelValue: _ctx.form.tenNhom,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.tenNhom) = $event)),
              maxlength: "150",
              disabled: _ctx.busy
            }, null, 8, ["modelValue", "disabled"]),
            _createElementVNode("p", null, _toDisplayString(_ctx.form.dichVuIds.length) + " dịch vụ · " + _toDisplayString(_ctx.form.nhanVienChinhIds.length) + " nhân viên chính · " + _toDisplayString(_ctx.form.nhanVienPhuIds.length) + " nhân viên phụ", 1),
            _createVNode(_component_TabView, null, {
              default: _withCtx(() => [
                _createVNode(_component_TabPanel, { header: "1. Dịch vụ trong nhóm" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BangChon, {
                      modelValue: _ctx.form.dichVuIds,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.dichVuIds) = $event)),
                      options: _ctx.services,
                      labelField: "tenDichVu",
                      valueField: "dichVu_Id",
                      disabled: _ctx.busy
                    }, null, 8, ["modelValue", "options", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_TabPanel, { header: "2. Nhân viên chính" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BangChon, {
                      modelValue: _ctx.form.nhanVienChinhIds,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.nhanVienChinhIds) = $event)),
                      options: _ctx.staff,
                      labelField: "tenNhanVien",
                      valueField: "nhanVien_Id",
                      danhTu: "nhân viên chính",
                      disabled: _ctx.busy
                    }, null, 8, ["modelValue", "options", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_TabPanel, { header: "3. Nhân viên phụ" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BangChon, {
                      modelValue: _ctx.form.nhanVienPhuIds,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.nhanVienPhuIds) = $event)),
                      options: _ctx.staff,
                      labelField: "tenNhanVien",
                      valueField: "nhanVien_Id",
                      danhTu: "nhân viên phụ",
                      disabled: _ctx.busy
                    }, null, 8, ["modelValue", "options", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["visible", "header", "closable", "closeOnEscape", "style"])
    ]),
    _: 1
  }))
}